<template>
  <div color="white"
    class="item"
    v-bind:class="{ passTime: isPassed }"
    style="cursor: pointer"
    @click="openDetail()"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title
          >{{ reservation.momentDate.format("HH:mm") }} Hrs.</v-list-item-title
        >
        <v-list-item-subtitle
          >Reservation: {{ reservation.Folio }}</v-list-item-subtitle
        >
        <v-list-item-subtitle
          >Name: {{ reservation.Cliente.Nombre }}</v-list-item-subtitle
        >
        <v-list-item-subtitle
          >{{ reservation.Cuentas.length }} Personas</v-list-item-subtitle
        >
        <div>
          <b>{{ reservation.TypeRes }}</b>
        </div>
      </v-list-item-content> 
      <v-list-item-action>
        <v-tooltip top v-if="alertMessage"> 
          <template v-slot:activator="{ on, attrs }"> 
            <v-chip 
              class="ma-2" 
              color="error" 
              outlined 
              v-bind="attrs" 
              v-on="on" 
            >
              !
            </v-chip>
          </template>
          <span>{{ alertMessage }}</span>
        </v-tooltip>

        <v-chip small color="primary">
          {{ reservation.Creador.Type }}
        </v-chip>
      </v-list-item-action>
    </v-list-item>
  </div>
</template>

<style scoped>
.passTime {
  /*background-color: #db282830 !important;*/
}
</style>

<script>
export default {
  name: "reservationListItem",
  components: {},
  props: ["reservation", "actualDate"],
  data() {
    return {};
  },
  methods: {
    openDetail() {
      this.$emit("clickedItem", this.$vnode.key);
    },
  },
  computed: {
    alertMessage() {
      if (
        this.actualDate.format("YYYY-MM-DD HH:mm") >
          this.reservation.momentDate.format("YYYY-MM-DD HH:mm") &&
        this.reservation.Estatus === "Confirmed"
      ) {
        return "Hora superada (Posible No Show)";
      } else if (this.reservation.Estatus === "Cancelled") {
        return "Reservación cancelada";
      }
      return null;
    },
    isPassed() {
      return !!this.alertMessage;
    },
  },
};
</script>
